module.exports = __webpack_public_path__ + "images/default_avatars/nightfall-938d761319c91827cbbc58cfbe66a313.jpg";